import { app } from '../../bootstrap/core';
import { legalState } from './legal.state';
import { legalComponent } from './legal.component';

app.config(legalState);
app.component(legalComponent.name, legalComponent);



// WEBPACK FOOTER //
// ./src/app/components/legal/legal.js